import { api } from './client';

/** Mirrors GoodsOperationService DTOs (Api/UseCases/Inventory). */
export interface GoodsOpLine {
  goodsId: number;
  quantity: number;
  unitCost: number;
}

export interface GoodsOperationResultDto {
  journalEntryId: number;
  documentNumber: string;
  operationCount: number;
}

export interface StockCardRowDto {
  date: string;
  documentNumber: string | null;
  content: string | null;
  quantityChange: number;
  unitValue: number;
  totalValue: number;
  runningQuantity: number;
  runningValue: number;
  warehouseId: number;
}

export interface StockCardDto {
  goodsId: number;
  goodsName: string;
  rows: StockCardRowDto[];
}

export interface WarehouseDto {
  id: number;
  name: string;
  warehouseAccount: number;
  isObsolete: boolean;
}

export const goodsOperationsApi = {
  acquire: (body: { date: string; warehouseId: number; counterAccount?: number | null; lines: GoodsOpLine[]; content?: string | null }) =>
    api.post<GoodsOperationResultDto>('/goods-operations/acquire', body),

  discard: (body: { date: string; warehouseId: number; costAccount?: number | null; lines: GoodsOpLine[]; content?: string | null }) =>
    api.post<GoodsOperationResultDto>('/goods-operations/discard', body),

  transfer: (body: { date: string; fromWarehouseId: number; toWarehouseId: number; lines: GoodsOpLine[]; content?: string | null }) =>
    api.post<GoodsOperationResultDto>('/goods-operations/transfer', body),

  inventorize: (body: { date: string; lines: { goodsId: number; warehouseId: number; countedQuantity: number; unitCost: number }[]; content?: string | null }) =>
    api.post<GoodsOperationResultDto>('/goods-operations/inventorize', body),

  stockCard: (params: { goodsId: number; warehouseId?: number; from: string; to: string }) =>
    api.get<StockCardDto>('/goods-operations/stock-card', {
      goodsId: params.goodsId,
      warehouseId: params.warehouseId,
      from: params.from,
      to: params.to,
    }),

  warehouses: () => api.get<WarehouseDto[]>('/inventory/warehouses'),
};
